import { ModalName, useModalStore } from '../../stores/modal'
import { AddPatient } from './AddPatient'
import { EmailSupport } from './EmailSupport'
import { Preview } from './Preview'
import { ReleaseInfo } from './ReleaseInfo'
import { ResetDemoPatients } from './ResetDemoPatients'
import { ResetUserSettings } from './ResetUserSettings'

export function Modals(): React.ReactNode {
  const [modal, modalParams, closeModal] = useModalStore((state) => [state.modal, state.modalParams, state.closeModal])

  return (
    <>
      <AddPatient
        isVisible={modal === ModalName.addPatient}
        onCancel={() => closeModal(ModalName.addPatient)}
        params={modalParams}
      />
      <EmailSupport
        isVisible={modal === ModalName.emailSupport}
        onCancel={() => closeModal(ModalName.emailSupport)}
        params={modalParams}
      />
      <ResetDemoPatients
        isVisible={modal === ModalName.resetDemoPatients}
        onCancel={() => closeModal(ModalName.resetDemoPatients)}
        params={modalParams}
      />
      <ResetUserSettings
        isVisible={modal === ModalName.resetUserSettings}
        onCancel={() => closeModal(ModalName.resetUserSettings)}
        params={modalParams}
      />
      <Preview
        isVisible={modal === ModalName.preview}
        onCancel={() => closeModal(ModalName.preview)}
        params={modalParams}
      />
      <ReleaseInfo
        isVisible={modal === ModalName.releaseInfo}
        params={modalParams}
        onCancel={() => closeModal(ModalName.releaseInfo)}
      />
    </>
  )
}
